<template>
  <v-row dense>
    <v-col cols="12">
      <dashboard-isfp-psfp-serie-temporal-isfp-tendencia
        :serieIsfp="serieIsfp"
        :loading="loading"
      />
    </v-col>

    <!-- <v-col cols="12">
      <dashboard-isfp-psfp-serie-temporal-psfp-tendencia
        ref="seriePsfp"
        :opcoesServicos="opcoesServicos"
        :loadingOpcoes="loading"
      />
    </v-col> -->

    <v-col cols="12">
      <dashboard-isfp-psfp-heatmap-tendencia
        :heatmap="heatmap"
        :competencias="competenciasHeatmap"
        :loading="algumLoading"
      />
    </v-col>
  </v-row>
</template>

<script>
import DashboardIsfpPsfpService from "@/services/DashboardIsfpPsfpService";

export default {
  name: "DashboardIsfpPsfpTendencia",
  components: {
    DashboardIsfpPsfpSerieTemporalIsfpTendencia: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpSerieTemporalIsfpTendencia.vue"
      ),
    DashboardIsfpPsfpSerieTemporalPsfpTendencia: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpSerieTemporalPsfpTendencia.vue"
      ),
    DashboardIsfpPsfpHeatmapTendencia: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpHeatmapTendencia.vue"
      ),
  },
  props: {
    activatedTab: { type: Number, required: true },
    competencia: { type: String, default: null },
    modoPeriodo: { type: String, default: "12m" },
    ano: { type: Number, default: null },
  },
  data: () => ({
    loading: false,
    loadingHeatmap: false,
    competencias: [],
    competenciasHeatmap: [],
    heatmap: [],
    serieIsfp: [],
    // opcoesServicos: [],
  }),
  mounted() {
    this.getDados();
  },
  methods: {
    getDados() {
      if (this.activatedTab !== 1) return;

      this.loading = true;
      this.getDadosHeatmap();

      DashboardIsfpPsfpService.getDadosTela2Tendencia(this.competencia)
        .then((res) => {
          this.competencias = res.competencias;
          this.serieIsfp = res.serie_isfp?.serie;
          // this.opcoesServicos = res.opcoes_servicos;

          // this.$nextTick(() => {
          //   if (this.$refs.seriePsfp) {
          //     this.$refs.seriePsfp.iniciar();
          //   }
          // });
        })
        .catch(() => {
          this.$toast.error("Erro ao recuperar dados.", "", {
            position: "topRight",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDadosHeatmap() {
      if (!this.competencia) return;

      this.loadingHeatmap = true;

      DashboardIsfpPsfpService.getDadosTela2HeatmapTendencia(
        this.competencia,
        this.modoPeriodo,
        this.modoPeriodo === "ano_civil" ? this.ano : null,
      )
        .then((res) => {
          this.competenciasHeatmap = res.competencias;
          this.heatmap = res.heatmap;
        })
        .catch(() => {
          this.$toast.error("Erro ao recuperar dados.", "", {
            position: "topRight",
          });
        })
        .finally(() => {
          this.loadingHeatmap = false;
        });
    },
  },
  computed: {
    algumLoading() {
      return this.loading || this.loadingHeatmap;
    },
  },
  watch: {
    activatedTab() {
      this.getDados();
    },
    competencia() {
      if (this.activatedTab === 1) {
        this.getDados();
      }
    },
    modoPeriodo() {
      if (this.activatedTab === 1) {
        this.getDados();
      }
    },
    ano() {
      if (this.activatedTab === 1) {
        this.getDados();
      }
    },
    algumLoading(val) {
      this.$emit("updateLoadingDados", val);
    },
  },
};
</script>

<style scoped></style>
